import { BsLockFill } from '@react-icons/all-files/bs/BsLockFill';
import React from 'react';
import classNames from 'classnames';

export function PoweredByLogo(props: {
  hideEncryptionMessage?: boolean;
  className?: string;
  vertical?: boolean;
}) {
  return (
    <div
      className={classNames(
        'flex text-gray-400 text-xs md:text-sm',
        props.vertical
          ? 'flex-col space-y-3'
          : 'flex-row items-center justify-center text-center sm:space-x-3',
        props.className,
      )}
    >
      <div
        className={classNames(
          !props.vertical && 'pt-0 mt-0 pl-0 pr-1.5 sm:pr-3 border-r flex',
        )}
      >
        <p className="whitespace-nowrap">
          Powered by
          <span className="font-bold text-blue-light"> InsurGrid</span>
        </p>
      </div>
      {!props.hideEncryptionMessage && (
        <div
          className={classNames(
            props.vertical
              ? 'flex mt-1 pb-3'
              : 'flex sm:pb-0 whitespace-nowrap ml-1.5',
          )}
        >
          <BsLockFill className="mr-1" />
          256-bit AES Military Grade Encryption
        </div>
      )}
    </div>
  );
}
